export enum RecommendationText {
    HighPrice = 'Dieser Gebrauchtwagen wird zu einem Preis angeboten, der deutlich über dem Durchschnittspreis für dieses Modell liegt. Hier lohnt es sich, den Anbieter nach Umbauten oder anderen Formen der Aufwertung zu fragen, welche den Preis des Fahrzeugs rechtfertigen könnten. Auch zusätzliche Ausstattung könnte hier eine Rolle spielen. Eventuell hast du hier einen guten Verhandlungsspielraum.',
    IncreasedPrice = 'Der Preis dieses Wagens ist etwas höher als der Durchschnittspreis. Überprüfe die Anzeige auf Details der Ausstattung oder frage beim Anbieter nach dem Zustand des Fahrzeugs und der Zusammensetzung des Preises nach.',
    FairPrice = 'Der Gebrauchtwagen liegt im guten Mittelfeld seiner möglichen Preisrange. Bei diesem Angebot ist ein zweiter Blick bestimmt hilfreich. Prüfe den Zustand des Wagens und ggf. zusätzliche Informationen.',
    GoodPrice = 'Der Preis für dieses Fahrzeug liegt leicht unter dem berechneten Durchschnittswert. Prüfe die Anzeige auf Zusatzausstattung oder mögliche Mängel. Sollten alle Informationen und Bilder deinen Erwartungen entsprechen, sprich den Anbieter an – hier kannst du einen guten Deal machen.',
    VeryGoodPrice = 'Der Preis ist überdurchschnittlich günstig und das Auto wird schnell verkauft sein - verliere keine Zeit und schreibe die Person an, die das Fahrzeug verkauft. Stelle sicher, dass alle Informationen der Wahrheit entsprechen und vereinbare einen Termin, um den Wagen genauer zu inspizieren. Achte auf nicht angegebene Mängel und hinterfrage den Preis.',
    NotSpecified = 'Wir möchten dir verlässliche Preisbewertungen liefern können. Jedoch gibt es Fälle, in denen wir die Qualität nicht garantieren können. Aus diesem Grund gibt es das Label „Keine Angabe“. Sobald sich die Gegenbenheiten ändern, wird auch für dieses Inserat eine Bewertung unsererseits für dich bereit gestellt.',
}

export interface ComparisonCriteria {
    headline?: string
    criterionGroup: CriterionGroup[]
}

export interface CriterionGroup {
    subheadline: string
    icon: any
    color: IconColor
    criteria: Criterion[]
}

export interface Criterion {
    label?: string
    value: number | string
}

export enum IconColor {
    Red = 'red',
    Green = 'green',
}
